import React, { useContext, useEffect, useRef, useState } from 'react';
import Header from '../../../../components/Common/Header/Header';
import { WelletContext } from '../../../../context/WelletContext';
import ContentApp from '../../../../components/ContentApp';
import { CircleSpinner } from 'react-spinners-kit';
import {
  fetchCampaignsFeed,
} from '../../../../services/campaigns/campaignsService';
import styles from './CampaignsFeed.module.css';
import CampaignMediaCard from '../../../../components/Common/CampaignMediaCard/CampaignMediaCard';
import { SkeletonCampaignFeed } from '../../../../components/Skeletons/SkeletonCreateCampaign';
import { useTranslation } from 'react-i18next';
import EmptyActivity from '../../../../components/Common/EmptyActivity/EmptyActivity';
import ErrorBox from '../../../../components/Common/ErrorBox/ErrorBox';
import useLazyLoad from '../../../../helpers/lazyLoad';
import { getQueryString } from '../../../../helpers/url';
import { useSelector } from 'react-redux';

const CampaignsFeedByShow = () => {
  const { t } = useTranslation();
  const showId = getQueryString('showId');
  const [show, setShow] = useState(null);
  const [media, setMedia] = useState(null);
  const [loading, setLoading] = useState(true);
  const [loadingMedia, setLoadingMedia] = useState(true);
  const welletContext = useContext(WelletContext);
  const language = useSelector((state) => state.app.language);
  const [errorMessage, setErrorMessage] = useState(null);

  const getShow = async () => {
    setLoading(true);
    try {
      const result = await welletContext.apis.tickets.get(`/shows/get/`, {
        params: {
          showId: showId,
          lang: language,
        },
      });

      setShow(result.data);
    } catch (error) {
      console.error(error);
    }
    setLoading(false);
  };

  const getData = async () => {
    try {
      setLoadingMedia(true);
      const body = {
        showId: showId,
        language,
      };
      const responseMedia = await fetchCampaignsFeed(welletContext, body);
      setMedia(responseMedia.data);
      setLoadingMedia(false);
    } catch (error) {
      setErrorMessage(t('callApiError'));
    }
  };

  useEffect(() => {
    getShow();
    getData();
  }, []);

  return (
    <div>
      <Header />
      {loading ? (
        <div className='loaderDiv'>
          <CircleSpinner
            className='spinner-app mx-auto'
            style={{ margin: 'auto' }}
            size={40}
            color='var(--color-font-primary)'
          />
        </div>
      ) : (
        <ContentApp>
          <div className='row'>
            <div className='col-auto pr-0'>
              <div className={`${show.visited ? styles.containerImg : styles.logoBorder}`}>
                <img className={styles.restaurantImg} src={show.logoUrl} alt={show.showName} />
              </div>
            </div>
            <div className='col my-auto'>
              <div className='font-normal fw-600'>{show.name}</div>
              <div className='text-secondary'>{show.city.name}</div>
            </div>
          </div>
          {errorMessage ? (
            <div className='mt-4'>
              <ErrorBox title={errorMessage} />
            </div>
          ) : loadingMedia ? (
            SkeletonCampaignFeed()
          ) :
            media.length <= 0 ?
              <div className='mt-4'><EmptyActivity title={t('noCampaigns')} /></div>
              :
              media.map((m, index) => (
                <LazyLoadedCampaignMediaCard key={index} campaign={m} />
              ))
          }
        </ContentApp>
      )}
    </div>
  );
};

const LazyLoadedCampaignMediaCard = ({ campaign, }) => {
  const [isVisible, elementRef] = useLazyLoad();

  return (
    <div ref={elementRef}>
      {isVisible ? (
        <CampaignMediaCard campaign={campaign} showImage={false} />
      ) : (
        <SkeletonCampaignFeed />
      )}
    </div>
  );
};

export default CampaignsFeedByShow;
